export const lssLangEn = {
  contact: {
    contactList: 'Contact List',
    callLog: 'CallLog',
    name: 'Name',
    phone: 'Phone',
    close: 'Close',   
    check: 'Check',
    searchName: 'Search Name'
  },
};
